import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Layers } from 'lucide-react';
export function PlatformOverview() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" id="platform" data-id="element-1015" data-mp="29ry118qiylkj">
      <div className="text-center mb-16" data-id="element-1016" data-mp="24qijhqnk2x6w">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-1017" data-mp="1zts0ovkd9nhs">
          Framework Structure
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-1018" data-mp="1uvqh89j13m5s">
          One framework. Multiple pathways for development.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-1019" data-mp="1m12g8vkhkqms">
        {/* Card 1: CJI */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="bg-surface-card rounded-lg p-8 lg:p-10 border border-line shadow-premium hover:shadow-premium-hover transition-shadow duration-300 relative overflow-hidden group" data-id="element-1020" data-mp="1h3k3sv79fta1">
          <div className="absolute top-0 left-0 w-full h-1 bg-navy transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-1021" data-mp="e6zamhnpc234"></div>

          <div className="w-12 h-12 rounded-md bg-surface-muted flex items-center justify-center text-navy mb-8 border border-line" data-id="element-1022" data-mp="16tsirl3f83n5">
            <Activity size={24} strokeWidth={1.5} data-id="element-1023" data-mp="1bs3objmonrzk" />
          </div>

          <div className="flex items-baseline gap-3 mb-4" data-id="element-1024" data-mp="wwntvdi6xu2n">
            <h3 className="text-2xl font-heading font-bold text-ink-dark" data-id="element-1025" data-mp="wy8qr9rz9p3o">
              CJI
            </h3>
            <span className="text-sm font-medium text-ink-muted" data-id="element-1026" data-mp="11x1zyq08ety1">
              Civic Judgment Index
            </span>
          </div>

          <p className="text-ink-muted leading-relaxed text-lg" data-id="element-1027" data-mp="3mlq26u49tl6w">
            The foundational assessment framework: defined reasoning and
            judgment tasks, assessment methods, and guidance for interpreting
            findings.
          </p>
        </motion.div>

        {/* Card 2: NCJI */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="bg-surface-card rounded-lg p-8 lg:p-10 border border-line shadow-premium hover:shadow-premium-hover transition-shadow duration-300 relative overflow-hidden group" data-id="element-1028" data-mp="1jc62w9ei284n">
          <div className="absolute top-0 left-0 w-full h-1 bg-teal transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-1029" data-mp="vh371hha34eo"></div>

          <div className="w-12 h-12 rounded-md bg-surface-muted flex items-center justify-center text-teal mb-8 border border-line" data-id="element-1030" data-mp="2pub83qvukc8r">
            <Layers size={24} strokeWidth={1.5} data-id="element-1031" data-mp="2xag4pycto6vj" />
          </div>

          <div className="flex items-baseline gap-3 mb-4" data-id="element-1032" data-mp="32aaw030ieyh4">
            <h3 className="text-2xl font-heading font-bold text-ink-dark" data-id="element-1033" data-mp="372lztgydf4ey">
              NCJI
            </h3>
            <span className="text-sm font-medium text-ink-muted" data-id="element-1034" data-mp="3c1yma0lby9h0">
              Neurocognitive Civic Judgment Index
            </span>
          </div>

          <p className="text-ink-muted leading-relaxed text-lg" data-id="element-1035" data-mp="2efrg4m9do92j">
            A broader developmental architecture integrating human opportunity,
            institutional readiness, civic resilience, and executive-level
            leadership evaluation.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="text-center" data-id="element-1036" data-mp="2t8ullv9p2wcw">
        <p className="inline-block px-6 py-3 bg-surface-muted rounded-full text-sm font-medium text-navy-light border border-line" data-id="element-1037" data-mp="684fz7mbd6nz">
          This is not a static score. It is a progression system.
        </p>
      </motion.div>
    </section>;
}